var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 18.396H0.476562V5.71631H3.875V18.396ZM0.277344 2.43506C0.277344 1.92725 0.445312 1.50928 0.78125 1.18115C1.125 0.853027 1.58984 0.688965 2.17578 0.688965C2.75391 0.688965 3.21484 0.853027 3.55859 1.18115C3.90234 1.50928 4.07422 1.92725 4.07422 2.43506C4.07422 2.95068 3.89844 3.37256 3.54688 3.70068C3.20312 4.02881 2.74609 4.19287 2.17578 4.19287C1.60547 4.19287 1.14453 4.02881 0.792969 3.70068C0.449219 3.37256 0.277344 2.95068 0.277344 2.43506Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.273 5.71631L10.3784 7.18115C11.2847 6.04834 12.4995 5.48193 14.023 5.48193C15.3667 5.48193 16.3667 5.87646 17.023 6.66553C17.6792 7.45459 18.0152 8.63428 18.0308 10.2046V18.396H14.6441V10.2866C14.6441 9.56787 14.4878 9.04834 14.1753 8.72803C13.8628 8.3999 13.3433 8.23584 12.6167 8.23584C11.6636 8.23584 10.9487 8.64209 10.4722 9.45459V18.396H7.08547V5.71631H10.273Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.3e3db72ec234d50f3b1aab9ce047d6b6.svg";
export { ForwardRef as ReactComponent };